var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 3.41675C2.91928 3.41675 2.5835 3.75254 2.5835 4.16675C2.5835 4.58096 2.91928 4.91675 3.3335 4.91675L16.6668 4.91675C17.081 4.91675 17.4168 4.58096 17.4168 4.16675C17.4168 3.75253 17.081 3.41675 16.6668 3.41675L3.3335 3.41675ZM2.5835 10.0001C2.5835 9.58587 2.91928 9.25008 3.3335 9.25008L16.6668 9.25008C17.081 9.25008 17.4168 9.58587 17.4168 10.0001C17.4168 10.4143 17.081 10.7501 16.6668 10.7501L3.3335 10.7501C2.91928 10.7501 2.5835 10.4143 2.5835 10.0001ZM2.5835 15.8334C2.5835 15.4192 2.91928 15.0834 3.3335 15.0834L16.6668 15.0834C17.081 15.0834 17.4168 15.4192 17.4168 15.8334C17.4168 16.2476 17.081 16.5834 16.6668 16.5834L3.3335 16.5834C2.91928 16.5834 2.5835 16.2476 2.5835 15.8334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBurgerMenu);
export default __webpack_public_path__ + "static/media/ic_burger_menu.783721d721f7a6c08ec15c1da69f169f.svg";
export { ForwardRef as ReactComponent };